/**
 * Base44 Utils - Sayfa URL oluşturma ve yardımcı fonksiyonlar
 */

/**
 * Sayfa URL'i oluşturur
 * Base44 platformundaki createPageUrl fonksiyonunu taklit eder
 *
 * @param {string} pageName - Sayfa adı (örn: "AdminDashboard", "AgentTasks")
 * @param {Object} params - URL parametreleri (opsiyonel)
 * @returns {string} URL string
 */
export function createPageUrl(pageName, params = {}) {
  // Sayfa adını route'a çevir
  const routeMap = {
    // Agent sayfaları
    'Home': '/',
    'AgentTasks': '/agent/tasks',
    'AgentLeads': '/agent/leads',
    'AgentOrders': '/agent/orders',
    'AgentCatalog': '/agent/catalog',
    'AgentProfile': '/agent/profile',
    'AgentReport': '/agent/report',
    // Warehouse sayfaları
    'WarehouseWarenausgang': '/warehouse/warenausgang',
    'WarehouseWareneingang': '/warehouse/wareneingang',
    'WarehouseDispo': '/warehouse/dispo',
    'WarehouseDashboard': '/warehouse/depo',
    'WarehouseInventur': '/warehouse/inventur',
    'WarehouseSuppliers': '/warehouse/suppliers',
    // Shipping sayfaları
    'ShippingDashboard': '/shipping',
    // Buchhaltung sayfaları
    'BuchhaltungRechnungen': '/buchhaltung/rechnungen',
    'BuchhaltungMahnungen': '/buchhaltung/mahnungen',
    'BuchhaltungGutschriften': '/buchhaltung/gutschriften',
    'BuchhaltungDashboard': '/buchhaltung/finanzen',
    'BuchhaltungJournal': '/buchhaltung/journal',
    'BuchhaltungKonten': '/buchhaltung/konten',
    'BuchhaltungBerichte': '/buchhaltung/berichte',
    'BuchhaltungBank': '/buchhaltung/bank',
    'BuchhaltungAusgaben': '/buchhaltung/ausgaben',
    'BuchhaltungWiederkehrend': '/buchhaltung/wiederkehrend',
    'BuchhaltungAnlagen': '/buchhaltung/anlagen',
    'BuchhaltungAbschluss': '/buchhaltung/abschluss',
    // Admin sayfaları
    'AdminDashboard': '/admin/dashboard',
    'AdminLeads': '/admin/leads',
    'AdminTasks': '/admin/tasks',
    'AdminOrders': '/admin/orders',
    'AdminProducts': '/admin/products',
    'AdminStockMovements': '/admin/stock-movements',
    'AdminSuppliers': '/admin/suppliers',
    'AdminAgents': '/admin/agents',
    'AdminReports': '/admin/reports',
    'AdminInbox': '/admin/inbox',
    'AdminLeadHunter': '/admin/lead-hunter',
    'AdminAgentPerformance': '/admin/performance',
    'AdminPdfSettings': '/admin/pdf-settings',
    'AdminEwkKategorien': '/admin/ewk-kategorien',
    'AdminIntegrationen': '/admin/integrationen',
    'AdminKundenportal': '/admin/kundenportal',
    'AdminShopifyOrders': '/admin/shopify-orders',
    'AdminEinstellungen': '/admin/einstellungen',
  };

  let url = routeMap[pageName] || `/${pageName.toLowerCase()}`;

  // Query parametreleri ekle
  if (Object.keys(params).length > 0) {
    const queryString = new URLSearchParams(params).toString();
    url += `?${queryString}`;
  }

  return url;
}

/**
 * Mevcut kullanıcı bilgisini döndürür
 * Demo mod için sabit değer döner
 */
export function getCurrentUser() {
  const saved = typeof window !== 'undefined' ? sessionStorage.getItem('inmotion_user') : null;
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (e) {
      // ignore
    }
  }
  return null;
}

/**
 * Admin mi kontrolü
 */
export function isAdmin() {
  const path = window.location.pathname;
  return path.startsWith('/admin');
}

/**
 * Agent mi kontrolü
 */
export function isAgent() {
  const path = window.location.pathname;
  return path.startsWith('/agent');
}

export default {
  createPageUrl,
  getCurrentUser,
  isAdmin,
  isAgent,
};
